import {Component, OnDestroy, OnInit} from '@angular/core';

import {AppTeam} from '@shared/models/team';
import {TeamService} from '@core/services/team.service';
import {StateService} from '@core/services/state.service';
import {AppLeague} from '@shared/models/league';
import {LeagueService} from '@core/services/league.service';
import {Sponsor} from '@shared/models/sponsor';
import {UserService} from '@core/services/user.service';
import {User} from '@shared/models/user';
import {SnackbarService} from '@core/services/snackbar.service';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';
import {EntityType} from '@lib/models/entity/entity-type';
import {FollowService} from '@core/services/follow/follow.service';

@Component({
  selector: 'app-league-teams',
  templateUrl: './league-teams.component.html',
  styleUrls: ['./league-teams.component.scss'],
})

export class LeagueTeamsComponent implements OnInit, OnDestroy {

  userSubscription;

  league: AppLeague;
  teams: AppTeam[] = [];
  sponsors: Sponsor[] = [];

  currentUser: User = null;
  teamsIsLoading = false;
  loading: boolean = false;
  entityType = EntityType.League;

  constructor( public leagueService: LeagueService,
               private teamService: TeamService,
               private userService: UserService,
               private followService: FollowService,
               private adCampaignService: AdCampaignService) { }

  ngOnInit() {
    this.league = this.leagueService.currentLeague;
    this.loadTeams(this.league.id);

    this.userSubscription = this.userService.currentUserSubject.subscribe(user => {
      this.currentUser = user;
    });

    this.userService.getCurrentUser().then(cu => this.currentUser = cu);
    this.adCampaignService.setPlacement(AdCampaignPlacement.Teams);
  }

  public ngOnDestroy() {
    this.userSubscription?.unsubscribe();
  }

  private loadTeams(leagueId: string) {
    this.teamsIsLoading = true;
    this.teamService.fetchTeamsOfLeague(leagueId).then(teams => {
      this.teams = teams;
      this.teamsIsLoading = false;
    }).catch(_ => {
      this.teams = [];
      this.teamsIsLoading = false;
    });
  }

  public async toggleFollow(follow: boolean, id: string) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    const name = this.teams.find(value => value.id === id).name;
    await this.followService.toggleFollow(follow, EntityType.Team, id, name)
    this.loading = false
  }
}
